/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { RootState, useTivoSelector } from '../../../../../core/tivo/tivo-redux-wrapper';
import { SelectMarkButtonProps } from './SelectMarkButtonProps';
import SelectMark from '../../../../../assets/images/hydra_icon_status_checkmark.png';
import './SelectMarkButton.scss';

const SelectMarkButton: FunctionComponent<SelectMarkButtonProps> = (props): JSX.Element => {
    const { text, isFocused, isSelected, id } = props;
    const { isOverlayGhostHighlightActive, verticalPosition } = useTivoSelector(
        (state: RootState) => state.overlayHighlight,
    );
    const isGhostHighlighted = isOverlayGhostHighlightActive && id === verticalPosition;

    return (
        <div
            className={`select-mark-button${isGhostHighlighted ? ' ghost-overlay' : ''}${
                isFocused ? ' select-mark-button-highlight-stroke' : ''
            }`}
            data-testid="select-mark-button-highlighted"
        >
            {isSelected ? (
                <img
                    src={SelectMark}
                    className="select-mark-button-icon"
                    data-testid="select-mark-button-icon"
                />
            ) : (
                <div className="select-mark-button-icon"></div>
            )}

            <div className={'select-mark-button-text'} data-testid="select-mark-button-text">
                {text}
            </div>
        </div>
    );
};

SelectMarkButton.propTypes = {
    id: PropTypes.number,
    text: PropTypes.string.isRequired,
    isFocused: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool,
};

export default SelectMarkButton;
